import React, { Component } from 'react';
import styled from 'styled-components';
import { WeatherItem, WeatherItemIcons } from './WeatherItem';
import Geosuggest from 'react-geosuggest';
//import RevieveActions from '../../store/RevieveActions';
import { translate } from 'react-polyglot';
import media from './MediaQueries';
import WeatherService from '../../services/Weather';
var mapsapi = require('google-maps-api')('AIzaSyDMFjIWuZ4zs9s0RtY3jq9F0vNnBTQ-TBQ', ['places']);

const StyledWeatherWidget = styled.div`
  background: rgba(0, 0, 0, 0.7);
  height: 120px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;

  ${media.phone`
    flex-direction: column;
    align-items: space-around;
    justify-content: center;
  `}

  .location {
    display: flex;
    flex-direction: column;
    width: 50%;
    padding: 0 40px;
    justify-content: center;

    ${media.phone`
      padding: 0;
      height: 36px;
      width: 100%;
    `}

    input[type="text"] {
      color: white;
      background: none;
      font-size: 20px;
      font-weight: 400;
      border: none;
      outline: none;
      width: 100%;
      ${media.phone`
        text-align: center;
      `}

      ${media.phone`
        font-size: 16px;
      `}

      &::placeholder {
        color: white;
      }
      + label {
        color: white;
        font-size: 12px;
        font-weight: 500;
        margin-top: 17px;
        text-decoration: underline;
      }
    }
  }

  .weatherStats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 50%;
    padding-right: 30px;

    ${media.phone`
      width: 100%;
      padding-right: 0;
      padding: 0 20px;
    `}
  }

  .geosuggest {
    height: 44px;
    font-size: 14px;
    font-size: 1rem;
    position: relative;
    width: 100%;
    text-align: left;
  }

  .geosuggest__input {
    position: absolute;
    top: 0;
    width: 100%;
    border: none;
    outline: none;
    padding: 0.5em 0;
    ${media.phone`
      text-align: center;
    `}
    -webkit-transition: border 200ms, box-shadow 200ms;
    transition: border 200ms, box-shadow 200ms;
  }
  .geosuggest__suggests {
    position: absolute;
    top: -250px;
    left: 0;
    right: 0;
    max-height: auto;
    padding: 0;
    color: white;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    list-style: none;
    /* z-index: 50000; */
    -webkit-transition: border 200ms, box-shadow 200ms;
    transition: border 200ms, box-shadow 200ms;

    ${media.phone`
      top: -140px;
      width: 100%;
      background: rgba(0,0,0,1);
      max-height: 120px;
    `}
  }
  .geosuggest__suggests--hidden {
    max-height: 0;
    overflow: hidden;
    border-width: 0;
  }

  .geosuggest__item {
    font-size: 14px;
    padding: 14px;
    cursor: pointer;
    margin-bottom: 5px;
    height: auto;
  }
  .geosuggest__item:hover,
  .geosuggest__item:focus {
    background: dodgerblue;
  }
  .geosuggest__item--active {
    background: dodgerblue;
    color: #fff;
  }
  .geosuggest__item--active:hover,
  .geosuggest__item--active:focus {
    background: dodgerblue;
  }
`;

class WeatherWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      loading: false,
      mapsapi: null,
      info: {},
      weatherService: new WeatherService(props.configOptions, props.revieveConfig),
    };
  }

  componentDidMount() {
    const { filters, defaultLocation } = this.props;
    this.state.weatherService.setFilters(filters);
    if (defaultLocation) {
      let that = this;
      mapsapi().then(maps => {
        let latlng = new maps.LatLng(defaultLocation.lat, defaultLocation.lon);
        let geocoder = new maps.Geocoder();
        geocoder.geocode({ latLng: latlng }, function(results, status) {
          if (status === maps.GeocoderStatus.OK) {
            let geocodification = {};
            geocodification.location = {
              lat: defaultLocation.lat,
              lng: defaultLocation.lon,
            };
            for (const result of results) {
              // we need to find the locality formatted_address element
              if (result.types[0] === 'locality') {
                geocodification.label = result.formatted_address;
                that.onSelect(geocodification);
                break;
              }
            }
          }
        });
      });
    } else {
      this.state.weatherService.doGeoIP().then(() => {
        this.state.weatherService.getWeather().then(info => {
          this.setState({ info });
        });
      });
    }
  }

  onSelect = e => {
    const { setLat, setLon } = this.props;
    let lat = e.location.lat;
    let lon = e.location.lng;
    setLat(lat);
    setLon(lon);
    let info = e.label.split(', ');
    this.state.weatherService.setInfo({
      city: info[0],
      display: info[0],
      area: info[0],
      country: info[1],
      lat: lat,
      lon: lon,
    });
    this.state.weatherService.getWeather().then(info => {
      this.setState({
        info,
        editing: false,
      });
    });
  };

  render = () => {
    const { t } = this.props;
    return (
      <StyledWeatherWidget className="revieve-weather-widget">
        <div className="location">
          {this.state.editing ? (
            <Geosuggest
              key="field1"
              placeholder={t('geosuggest_placeholder')}
              ref={el => (this._geoSuggest = el)}
              googleMaps={this.state.mapsapi}
              onSuggestSelect={this.onSelect}
              onBlur={() => {
                this.setState({ editing: false });
              }}
            />
          ) : (
            <div>
              <input
                type="text"
                placeholder={
                  this.state.info.city || this.state.info.country || this.state.info.display || 'Loading weather ...'
                }
                onClick={() => {
                  this.setState({ loading: true });
                  mapsapi().then(maps => {
                    this.setState({ loading: false, editing: true, mapsapi: maps });
                    this._geoSuggest.focus();
                  });
                }}
              />
              {/*<label htmlFor="">change location</label>*/}
            </div>
          )}
        </div>
        <div className="weatherStats">
          <WeatherItem
            value={this.state.info.uv_index || '...'}
            icon={WeatherItemIcons.uv}
            label={t('uv_index')}
            selected={true}
          />
          <WeatherItem
            value={(this.state.info.humidity && this.state.info.humidity.toFixed(0) + '%') || '...'}
            icon={WeatherItemIcons.humidity}
            label={t('humidity')}
          />
          <WeatherItem
            value={this.state.info.pollution || '...'}
            icon={WeatherItemIcons.pollution}
            label={t('pollution')}
          />
        </div>
      </StyledWeatherWidget>
    );
  };
}

export default translate()(WeatherWidget);



// WEBPACK FOOTER //
// ./src/components/instore/WeatherWidget.js